import { render, staticRenderFns } from "./CrmAniversariantesPage.vue?vue&type=template&id=55190ac0&scoped=true&"
import script from "./CrmAniversariantesPage.vue?vue&type=script&lang=js&"
export * from "./CrmAniversariantesPage.vue?vue&type=script&lang=js&"
import style0 from "./CrmAniversariantesPage.vue?vue&type=style&index=0&id=55190ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55190ac0",
  null
  
)

export default component.exports